import { render, staticRenderFns } from "./MovieCategory.vue?vue&type=template&id=9581838a&"
import script from "./MovieCategory.vue?vue&type=script&lang=js&"
export * from "./MovieCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports